var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { useContact3DPlayerRecords } from "../../../game/contact3d/replicatedObjects/Contact3DPlayerRecords";
import { toCssColorString } from "../util/ColorPreset";
import { getLightPlayerColor } from "../util/PlayerColors";
import { PlayerTag } from "./PlayerTag";
import { VisualContainer } from "./VisualContainer";
export const PlayerOwnedContainer = (props) => {
    const { playerId, style } = props, rest = __rest(props, ["playerId", "style"]);
    const { record: playerRecords } = useContact3DPlayerRecords();
    const borderColor = useMemo(() => {
        if (playerId === undefined) {
            return '#FFFFFF';
        }
        const playerRecord = playerRecords[playerId];
        const index = playerRecord === null || playerRecord === void 0 ? void 0 : playerRecord.index;
        return toCssColorString(getLightPlayerColor(index));
    }, [playerId, playerRecords]);
    return _jsxs(VisualContainer, Object.assign({ style: Object.assign({ borderColor, position: 'relative' }, style) }, rest, { children: [playerId !== undefined && _jsx(PlayerTag, { playerId: playerId, absolutePositioning: { top: props.padding, right: props.padding } }), props.children] }));
};
//# sourceMappingURL=PlayerOwnedContainer.js.map